import React from "react";
import SText from "styled42/components/SText";
import VernacManager from "utils/vernacular";
import OptionComponent from "../utils/OptionComponent";
import { qualificationOptions, MandatorySText } from "./utils";

const Label = (props) => {
  return (
    <SText size={16}>
      {VernacManager.translateString("job_interest_select_your_edu")}{" "}
      <SText style={{ fontWeight: "bold" }}>
        {VernacManager.translateString("job_interest_highest_qualification")}
      </SText>
    </SText>
  );
};

const QualificationComponent = ({ value, handleStateChange }) => (
  <>
    {/* <MandatorySText text={<Label/>} /> */}
    <Label />
    <OptionComponent
      options={qualificationOptions}
      responseValue={value}
      setResponseValue={(qualification) => {
        handleStateChange({
          component: "qualification",
          value: qualification.value
        });
      }}
    />
  </>
);

export default QualificationComponent;
